import React, {useEffect, useState} from "react";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import ContentArea from "../ContentArea";
import ButtonBlock from "../ButtonBlock";
import MediaArea from "../MediaArea";

const OverlayedLayout = ({ settings, blocks, props }) => {
  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
  const { globals } = props;

  const layout = isMobile ? settings.layout_type_mobile : settings.layout_type;
  const description = settings.content || '';
  const classes = settings.classes || '';

  return (
    <div className={`${classes} twi-${layout}`}>
      <div className={`image-container overlay content-over-media`}>
        <MediaArea globals={globals} settings={settings} isMobile={isMobile} />
        <div className={`twi-container`}>
          <div className="twi-content">
            <ContentArea settings={settings} description={description} isMobile={isMobile} />
            <ButtonBlock blocks={blocks} settings={settings} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverlayedLayout;
